/*globals Vitafy */

import { createGAListObject } from '!/common/helpers';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Hit, HitListView, } from '@web/vitafy-react-components';

// TODO
function sendGAEvent(category, action, label) {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: "ga-event",
      'event-action': action,
      'event-cat': category,
      'event-label': label
    });
  }
}

class Hits extends PureComponent {
  static propTypes = {
    hits: PropTypes.array.isRequired,
    settingsLayout: PropTypes.shape({
      default: PropTypes.string,
      vomachterhof: PropTypes.string
    }),
    perPage: PropTypes.number,
    currentPage: PropTypes.number,
    values: PropTypes.object.isRequired
  };

  static defaultProps = {
    hits: [],
    settingsLayout: 'list'
  };

  componentDidMount() {
    createGAListObject(this.props.perPage, this.props.currentPage, this.props.values);
  }

  componentDidUpdate(prevProps) {
    const filtersApplied = prevProps.total !== this.props.total;

    if (this.props.total === 0) {
      sendGAEvent('Search Filter', 'Zero Matches');
    }

    if (
        // if the first hit has a different sku we'er either on a
        // new page or applied a filter
        prevProps.hits[0]?.sku !== this.props.hits[0]?.sku ||
        // if a filter was applied the first hit could still have the same
        // sku, but the total hit count changed
        filtersApplied
    ) {
      createGAListObject(this.props.perPage, this.props.currentPage, this.props.values);
    }
  }

  render() {
    const { isDebugMode, hits, settingsLayout, storeCode, shopsWithWishlist } = this.props;
    const showWishButton = shopsWithWishlist.indexOf(storeCode) >= 0;

    const currentLayout = settingsLayout[storeCode] || settingsLayout['default'];
    let imgParameter = 'b_white,c_pad,f_auto,fl_force_strip.preserve_transparency.progressive';

    const generateResponsiveImage = item => ({
        normal: `${item.image.baseUrl}${imgParameter},h_240,w_240${item.image.path}`,
        size300w: `${item.image.baseUrl}${imgParameter},h_300,w_300${item.image.path}`,
        size400w: `${item.image.baseUrl}${imgParameter},h_400,w_400${item.image.path}`,
        size500w: `${item.image.baseUrl}${imgParameter},h_500,w_500${item.image.path}`,
        thumbnail: `${item.image.baseUrl}${imgParameter},h_25,w_25${item.image.path}`
      });

    if (hits.length === 0) {
      return <div style={{'font-size': '28px', 'font-weight': 'bold', 'text-align': 'center', 'max-width': '200px', 'margin': '3rem auto 4rem'}}>Leider wurde kein passendes Produkt gefunden</div>;
    }

    return (
      <section className={`l-row search-layout__hits`}>
        {hits.map((item, index) => isDebugMode ? (
          <div className="l-col l-col--4/12@desktop">
            <Hit key={index} {...item} image={generateResponsiveImage(item)} layout={currentLayout} wishButton={showWishButton} code={storeCode} />
          </div>
        ) : (
          <HitListView cls="l-col l-col--6/12@desktop" key={index} {...item} image={generateResponsiveImage(item)} layout={currentLayout} wishButton={showWishButton} code={storeCode} />
        ))}
      </section>
    );
  }
}

function mapStateToProps({ hits, isDebugMode, settings, page, perPage, values, total, storeCode, shopsWithWishlist }) {
  return {
    hits,
    isDebugMode,
    settingsLayout: settings.layout,
    currentPage: page, // req. GA list impression tracking
    perPage, // req. GA list impression tracking
    values, // req. GA list impression tracking
    total,
    storeCode,
    shopsWithWishlist,
  };
}

export default connect(mapStateToProps)(Hits);
